import React from "react";
import { motion } from "framer-motion";
import { Eye, Heart, MessageCircle, Bookmark } from "lucide-react";
import { formatCompact, formatDate } from "@/lib/format";

const scoreColor = (s) =>
  s >= 75 ? "text-emerald-600 dark:text-emerald-400 bg-emerald-500/10 border-emerald-500/20"
  : s >= 50 ? "text-amber-600 dark:text-amber-400 bg-amber-500/10 border-amber-500/20"
  : "text-rose-600 dark:text-rose-400 bg-rose-500/10 border-rose-500/20";

export const ReelCard = ({ reel, onClick, index = 0 }) => {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: Math.min(index * 0.03, 0.3) }}
      className="group text-left overflow-hidden rounded-2xl border border-border bg-card shadow-sm hover:border-brand-500/40 hover:-translate-y-1 transition-all"
      data-testid={`reel-card-${reel.reel_id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-muted">
        <img src={reel.thumbnail_url} alt={reel.topic} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/70 to-transparent" />
        <div className={`absolute top-2.5 right-2.5 rounded-full border px-2 py-0.5 text-xs font-bold backdrop-blur ${scoreColor(reel.growth_score)}`}>
          {reel.growth_score}
        </div>
        <div className="absolute bottom-2 left-2.5 flex items-center gap-1 text-white text-xs font-medium">
          <Eye className="h-3.5 w-3.5" /> {formatCompact(reel.views)}
        </div>
      </div>
      <div className="p-3.5 space-y-2">
        <div className="text-xs font-mono uppercase tracking-wide text-brand-700 dark:text-brand-400 truncate">{reel.topic}</div>
        <p className="text-sm line-clamp-2 leading-snug">{reel.hook}</p>
        <div className="flex items-center justify-between pt-1 text-xs text-muted-foreground">
          <span>{formatDate(reel.published_at)}</span>
          <div className="flex items-center gap-2.5">
            <span className="flex items-center gap-1"><Heart className="h-3 w-3" />{formatCompact(reel.likes)}</span>
            <span className="flex items-center gap-1"><MessageCircle className="h-3 w-3" />{formatCompact(reel.comments)}</span>
            <span className="flex items-center gap-1"><Bookmark className="h-3 w-3" />{formatCompact(reel.saves)}</span>
          </div>
        </div>
      </div>
    </motion.button>
  );
};
